
      import OrderReport from './order-report.vue'
      import type { App, Plugin } from 'vue'

      export const OrderReportPlugin: Plugin = {
        install(app: App) {
          app.component('OrderReport', OrderReport)
        },
      }
      export { OrderReport }
      